import { useQuery } from '@apollo/client';
import { GET_USER_FOLLOWERS, GET_USER_FOLLOWING } from '../graphql/queries';

export const useGetUserFollowers = (userId: string, first: number = 20) => {
  return useQuery(GET_USER_FOLLOWERS, {
    variables: { userId, first, page: 1 },
    skip: !userId,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true
  });
};

export const useGetUserFollowing = (userId: string, first: number = 20) => {
  return useQuery(GET_USER_FOLLOWING, {
    variables: { userId, first, page: 1 },
    skip: !userId,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true
  });
}; 